export default function TopTrustBar() {
  return (
    <div className="fixed top-0 left-0 right-0 z-[55] w-full bg-brand-dark/95 backdrop-blur-sm border-b border-white/10">
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-center gap-3 md:gap-6 py-2.5 overflow-x-auto whitespace-nowrap text-xs md:text-sm text-white/80">
          <span className="flex items-center gap-1 text-yellow-400 font-semibold">
            <i className="ri-star-fill text-yellow-400 text-xs"></i>
            4.9/5
          </span>
          <span className="text-white/30 select-none">·</span>
          <span className="text-white/80">+10 ans sur Paris 15</span>
          <span className="text-white/30 select-none">·</span>
          <span className="text-white/80">Devis gratuit 24/48h</span>
          <span className="text-white/30 select-none hidden sm:inline">·</span>
          <span className="hidden sm:inline text-white/80">Société assurée</span>
          <span className="text-white/30 select-none hidden sm:inline">·</span>
          <span className="hidden sm:inline text-white/80">Techniciens salariés</span>
          <span className="text-white/30 select-none">·</span>
          <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-brand-accent/20 text-brand-accent font-semibold rounded-full">
            <i className="ri-shield-check-line text-[10px]"></i>
            Spécialiste Paris 15
          </span>
        </div>
      </div>
    </div>
  );
}